import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpInterceptorService, RESTService } from '@covalent/http';
import { MOCK_API } from '../config/api.config';
import { Observable } from 'rxjs/Observable';
import { environment } from '../environments/environment';
import 'rxjs/add/operator/map';

@Injectable()
export class DocumentosService extends RESTService<any> {

  constructor(private _http: HttpInterceptorService) {
    super(_http, {
      baseUrl: MOCK_API,
      path: '/obtenerPlanTratamientoPaciente',
    });
  }

  obtenerInformesTodos(idPaciente: string, agenda: string, centro: string, dni: string): any {
    return this._http.post(environment.api_host + 'documentos/obtenerInformesTodos',
      {
        idPaciente: idPaciente,
        idInforme: '-1',
        agenda: agenda,
        centro: centro,
        dni: dni,
      }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerInformesClinico(idPaciente: string): any {
    return this._http.post(environment.api_host + 'documentos/obtenerInformesClinico',
      {
        idPaciente: idPaciente,
        idInforme: '-1',
      }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerJustificantes(idPaciente: string, agenda: string, centro: string, dni: string): any {
    return this._http.post(environment.api_host + 'documentos/obtenerJustificantes',
      {
        idPaciente: idPaciente,
        agenda: agenda,
        centro: centro,
        dni: dni,
      }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerInformesContCuidados(idPaciente: string, centro: string, dni: string): any {
    return this._http.post(environment.api_host + 'documentos/ObtenerInformesContCuidados',
      {
        idPaciente: idPaciente,
        sCodCentro: centro,
        sDNI: dni,
      }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerInformePdf(idDocumento: string): any {
    return this._http.post(environment.api_host + 'documentos/obtenerInformePdf', { idDocumento: idDocumento, })
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerJustificantePdf(fecha: string, fecvisita: string, horvisita: string, nomcen: string,
                        pacienteNombre: string, pacienteApellidos: string, pacienteDni: string,
                        profesionalNombre: string, profesionalApellido1: string, profesionalApellido2: string): any {
    return this._http.post(environment.api_host + 'documentos/obtenerJustificantePdf',
      {
        fecha: fecha,
        fecvisita: fecvisita,
        horvisita: horvisita,
        nomcen: nomcen,
        paciente_nombre: pacienteNombre,
        paciente_apellidos: pacienteApellidos,
        paciente_dni: pacienteDni,
        profesional_nombre: profesionalNombre,
        profesional_apellidos: profesionalApellido1 + '' + profesionalApellido2,
      },
    ).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

}



// WEBPACK FOOTER //
// ./src/services/documentos.service.ts